import { useState, useEffect, useRef } from "react";
import { BUTTON_POSITION_BREAKPOINT } from "@shared/constants/breakpoints";

function clearPendingUpdates(rafRef: React.MutableRefObject<number | null>, timeoutRef: React.MutableRefObject<NodeJS.Timeout | null>): void {
  if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
  if (timeoutRef.current !== null) clearTimeout(timeoutRef.current);
}

export const useIsMobileButtons = (): boolean => {
  const [isMobileButtons, setIsMobileButtons] = useState<boolean>(() => {
    return typeof window !== "undefined" && window.innerWidth < BUTTON_POSITION_BREAKPOINT;
  });

  const rafRef = useRef<number | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      clearPendingUpdates(rafRef, timeoutRef);
      timeoutRef.current = setTimeout(() => {
        rafRef.current = requestAnimationFrame(() => {
          const newIsMobileButtons = window.innerWidth < BUTTON_POSITION_BREAKPOINT;
          setIsMobileButtons(prev => prev !== newIsMobileButtons ? newIsMobileButtons : prev);
        });
      }, 100);
    };

    window.addEventListener("resize", handleResize, { passive: true });
    return () => {
      window.removeEventListener("resize", handleResize);
      clearPendingUpdates(rafRef, timeoutRef);
    };
  }, []);

  return isMobileButtons;
};

